import { Container } from "@material-ui/core";
import ComingSoon from './ComingSoon';

export default function Race() {
  return (
    <Container>
      <ComingSoon name="iRacing news, recent races, VODs, and more!"/>
    </Container>
  );
}